//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "Footer",
  data() {
    return {
      user: null,
    };
  },
  created() {
  },
};
